/**
 * Performance PDP flat Skio layout: each interval is its own radio with value=selling_plan id.
 * Skio's script still drives state from the hidden <select skio-selling-plans="…">.
 * Sync select from the checked plan radio before Skio's change handlers run (capture phase).
 */
(function () {
  function syncSelectFromRadio(radio) {
    var gid = radio.getAttribute("skio-selling-plan-group");
    if (!gid) return;
    var fieldset = radio.closest(".skio-plan-picker--split-layout");
    if (!fieldset) return;
    var sel = fieldset.querySelector(
      'select.delivery-input[skio-selling-plans="' + gid + '"]'
    );
    if (!sel || sel.value === radio.value) return;
    sel.value = radio.value;
  }

  function syncAll() {
    document
      .querySelectorAll(
        ".skio-plan-picker--split-layout input.skio-group-input[skio-selling-plan-group]:checked"
      )
      .forEach(syncSelectFromRadio);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll);
  } else {
    syncAll();
  }

  document.addEventListener(
    "change",
    function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (!t.closest(".skio-plan-picker--split-layout")) return;
      if (
        !t.matches(
          'input.skio-group-input[type="radio"][skio-selling-plan-group]'
        )
      )
        return;
      syncSelectFromRadio(t);
    },
    true
  );
})();
